
import Hero from "../../components/Hero";
import Category from "../../components/Category";
import FormInput from "../../components/FormInput";
import FormTextarea from "../../components/FormTextarea";
import Page from "../../components/Page.vue";
import CategoryFilters from "../../components/CategoryFilters.vue";
import {
    createBreadcrumbSchema,
    createItemListSchema,
    createSchemaHead,
    getAbsoluteImageUrl,
    getAbsoluteUrl,
    getCanonicalUrl,
    getSiteCurrency,
} from "../../utils/schema";
export default {
    name: 'CatalogPage',
    components: {CategoryFilters, Page, FormTextarea, FormInput, Category, Hero},
    async asyncData({ $axios, route, error, redirect }) {
        try {
            const res = await $axios.get('api/v1/products/category', {
                params: {
                    slug: route.params.slug,
                    gender: route.query.gender,
                    type: route.query.type,
                    size: route.query.size,
                    racket_type: route.query.racket_type,
                    game: route.query.game,
                    age: route.query.age,
                }
            });

            const navigation = (res.data.filters && res.data.filters.navigation) || {};
            const navigationKey = Object.keys(navigation).find(key => Object.prototype.hasOwnProperty.call(route.query, key));
            if (navigationKey) {
                const option = res.data.filters.options[navigationKey].find(item => item.id === route.query[navigationKey]);
                const query = {...route.query};
                delete query[navigationKey];
                redirect(301, option ? option.url : navigation[navigationKey].reset_url, query);
                return;
            }

            return {
                products: res.data.products,
                category: res.data.category,
                h1: res.data.category.seo_h1,
                title: res.data.category.seo_title,
                description: res.data.category.seo_description,
                bannerHead: res.data.bannerHead,
                filters: res.data.filters,
            }
        }
        catch (e) {
            console.log(e);
            error({ statusCode: 404, message: 'Category not found' });
        }
    },
    watchQuery: [
        'gender',
        'type',
        'size',
        'racket_type',
        'game',
        'age',
    ],
    head() {
        const canonical = this.canonicalUrl;
        const breadcrumb = createBreadcrumbSchema(this, [
            { name: 'Главная', path: '/' },
            { name: this.h1 || this.category.name, path: this.$route.path || '/' },
        ], '#breadcrumbs');
        const itemList = createItemListSchema(this, this.products.map((product) => ({
            name: product.name,
            url: getAbsoluteUrl(this, `/catalog/product/${product.alias}/`),
            image: getAbsoluteImageUrl(this, product.image && product.image.sizes ? (product.image.sizes.medium || product.image.path) : null),
            price: product.price_special || product.price || null,
            available: product.available,
            currency: getSiteCurrency(this),
        })), '#category-items');
        const schemaHead = createSchemaHead([
            {
                '@type': 'CollectionPage',
                '@id': `${canonical}#webpage`,
                url: canonical,
                name: this.title || this.category.name,
                description: this.description || undefined,
                breadcrumb: breadcrumb ? {
                    '@id': breadcrumb['@id'],
                } : undefined,
                mainEntity: itemList ? {
                    '@id': itemList['@id'],
                } : undefined,
            },
            breadcrumb,
            itemList,
        ], 'schema-org-category');

        return {
            title: this.title,
            meta: [
                { hid: 'description', name: 'description', content: this.description },
                { hid: 'keywords', name: 'keywords', content: '' },
            ],
            link: [
                { hid: 'canonical', rel: 'canonical', href: canonical },
            ],
            ...schemaHead,
        }
    },
    data() {
        return {
            seo: false,
            process: false,
        }
    },
    computed: {
        hasFilters() {
            return this.filters && (['odezhda', 'tennisnaya_odezhda', 'detskaya_odezhda'].includes(this.category.alias)
                || ['racket_type', 'game', 'age'].some(key => Array.isArray(this.filters.options[key])));
        },
        canonicalUrl() {
            return getCanonicalUrl(this);
        },
    },
    methods: {
        selectFilter(key, value){
            this.filters.values[key] = value;
            this.process = true;
            this.$nextTick(this.useFilter);
        },
        clearFilterItem(key){
            this.filters.values[key] = null;
            this.process = true;
            this.$nextTick(this.useFilter);
        },
        clearFilterAll(){
            Object.keys(this.filters.values).forEach(key => {this.filters.values[key] = null;});
            this.process = true;
            this.$nextTick(this.useFilter);
        },
        async useFilter(){
            const activeFilters = Object.keys(this.filters.values)
                .filter(key => (this.filters.values[key] !== null))
                .reduce((acc, key) => {
                    acc[key] = this.filters.values[key];
                    return acc;
                }, {});
            const navigation = this.filters.navigation || {};
            const navigationKey = Object.keys(navigation)[0];
            let path = '/catalog/' + this.$route.params.slug + '/';
            if (navigationKey) {
                const option = this.filters.options[navigationKey].find(item => item.id === this.filters.values[navigationKey]);
                path = option ? option.url : navigation[navigationKey].reset_url;
                delete activeFilters[navigationKey];
            }
            const query = new URLSearchParams(activeFilters).toString();
            const url = path + (query || !navigationKey ? '?' + query : '');
            try {
                await this.$router.push(url);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (error) {
                if (error.name !== 'NavigationDuplicated') throw error;
            } finally {
                this.process = false;
            }
        },
        async submit(){
            this.process = true;
            try {
                let response = await this.$axios.post('/api/v1/seo/category', {
                    id: this.category.id,
                    seo_h1: this.h1,
                    seo_title: this.title,
                    seo_description: this.description,
                });
                this.process = false;
                this.seo = false;
            } catch (e) {
                if (e.response.status === 422) {
                    this.error = 'Некорректно отправлена форма';
                } else {
                    this.error = 'Системная ошибка, попробуйте позже';
                }
                alert(this.error);
                this.process = false;
            }
        },
    },
}
